import React, { useState, useRef, useEffect } from 'react';

import StyleFabricDetailComponent from './StyleFabricDetailComponent';

import * as ProductService from '../../../services/Product.service';
import { init } from '../../../data/App.data';

const StyleFabricDetailContainer = props => {

    const { windowDimensions } = props;

    const [info, setInfo] = useState(null);
    const [selectedImageIdx, setSelectedImageIdx] = useState(0);
    const [isShowImagePopup, setIsShowImagePopup] = useState(false);
    const [detailMode, setDetailMode] = useState('image');
    const [movieUrl, setMovieUrl] = useState(null);
    const [mobileMovieUrl, setMobileMovieUrl] = useState(null);

    useEffect(_ => {
        async function init(id) {
            const info = await ProductService.getInfo(id);
            console.log('info', info);
            setInfo(info);
        }
        const id = props.match.params['id'];
        init(id);

        document.addEventListener("fullscreenchange", onFullScreenChange);
        document.addEventListener("webkitfullscreenchange", onFullScreenChange);
        document.addEventListener("mozfullscreenchange", onFullScreenChange);

        return (_ => {
            document.removeEventListener("fullscreenchange", onFullScreenChange);
            document.removeEventListener("webkitfullscreenchange", onFullScreenChange);
            document.removeEventListener("mozfullscreenchange", onFullScreenChange);
        });
    }, [])

    const onFullScreenChange = evt => {
        if (!(document.fullScreen ||
            document.mozFullScreen ||
            document.webkitIsFullScreen)) {
            console.log('not fullscreen');
            setMobileMovieUrl(null);
        }
    }

    const onMouseOverItem = idx => {
        setSelectedImageIdx(idx);
        setDetailMode('image');
    }
    const onClickBtnShowImagePopup = _ => {
        setIsShowImagePopup(true);
    }
    const onClickBtnCloseImagePopup = _ => {
        setIsShowImagePopup(false);
    }

    const onClickBtnMovie = movieUrl => {
        console.log(movieUrl);
        setMovieUrl(movieUrl);
        setDetailMode('movie');
    }

    const onClickBtnMobileMovie = movieUrl => {
        console.log(movieUrl);
        setMobileMovieUrl(movieUrl);
        // setDetailMode('movie');
    }

    const onEndedMobileVideo = _ => {
        console.log('onEndedMobileVideo');
        setMobileMovieUrl(null);
    }
    const onPauseMobileVideo = _ => {
        console.log('onPauseMobileVideo');
        setMobileMovieUrl(null);
    }

    const onClickBtnThumbnail = idx => {
        console.log('onClickBtnThumbnail', idx);
        setSelectedImageIdx(idx);
        setIsShowImagePopup(true);
    }

    return (
        info ?
            <StyleFabricDetailComponent
                detailMode={detailMode}
                movieUrl={movieUrl}
                onMouseOverItem={onMouseOverItem}
                onClickBtnMovie={onClickBtnMovie}
                onClickBtnShowImagePopup={onClickBtnShowImagePopup}
                onClickBtnCloseImagePopup={onClickBtnCloseImagePopup}
                onClickBtnThumbnail={onClickBtnThumbnail}
                selectedImageIdx={selectedImageIdx}
                isShowImagePopup={isShowImagePopup}
                windowDimensions={windowDimensions}
                onClickBtnMobileMovie={onClickBtnMobileMovie}
                mobileMovieUrl={mobileMovieUrl}
                onEndedMobileVideo={onEndedMobileVideo}
                onPauseMobileVideo={onPauseMobileVideo}
                info={info} />
            : null
    )
}

export default StyleFabricDetailContainer;